import { useEffect } from "react";

// পূর্ণ static pre-rendering (SEO-র জন্য) এখনো সেট আপ করা হয়নি — এটা শুধু
// client-side-এ title/description বদলায় (social share preview আর ব্রাউজার
// ট্যাবের জন্য কাজে লাগে)। প্রকৃত crawler-friendly per-page HTML পেতে পরে
// vite-react-ssg বা Next.js migration লাগবে — README-তে নোট করা আছে।
export function useMeta({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
}
